export const fmtNum = (n) =>
  n === null || n === undefined ? "N/D" : Number(n).toLocaleString("es-ES");

export const fmtPts = (n) =>
  n === null || n === undefined
    ? "—"
    : Number(n).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const playerMinutes = (p) =>
  p?.minutos_disponibles === "Sí" && p?.minutos_total_app != null ? p.minutos_total_app : null;
